var _path, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 7,
  r: 4
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 17,
  x2: 22,
  y1: 16,
  y2: 11
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 17,
  x2: 22,
  y1: 11,
  y2: 16
})));
export { SvgUserX as ReactComponent };
export default __webpack_public_path__ + "static/media/UserX.25b5d837f03dcccda9fbfab410479c93.svg";